import { useDispatch } from "react-redux";
import Cookies from "js-cookie";

import { getOrders } from "../../../../redux/actions/catalogue.action";

export const useFetchOrderHistory = () => {
    const groupCustomerId = Cookies.get("groupCustomerId");
    const dispatch = useDispatch();

    const handleGetOrders = () => {
        const params = {
            OwnerID: groupCustomerId,
            Channel: 2,
        };
        dispatch(getOrders(params));
    };

    return handleGetOrders;
};
